// Proper, user-facing labels for card fields — the source of truth for the
// "Missing information" tooltip (StateCell) so an `errors` / `suggested_edits`
// key renders as the name the user recognises.
//
// Why not read AG Grid `headerName`? Those are inconsistent across the batch and
// inventory grids (e.g. `sport`→"category", `title`→"product name",
// `player`→"name"), so they'd produce the wrong tooltip label. This curated map
// is keyed by the BE field name that appears in `errors` / `suggested_edits`.
export const CARD_FIELD_LABELS = {
  title:          'Title',
  sport:          'Sport',
  player:         'Name',
  name:           'Name',
  set:            'Set',
  team:           'Team',
  year:           'Year',
  brand:          'Brand',
  start_price:    'Sale Price',
  card_number:    'Card #',
  subset:         'Subset/Parallel',
  variation:      'Variation',
  condition:      'Condition',
  grade_number:   'Grade',
  grader:         'Grader',
  cert_no:        'Cert No.',
  graded:         'Graded',
  attributes:     'Attributes',
  weight_oz:      'Weight (oz)',
  purchase_price: 'Purchase Price',
  purchase_date:  'Purchase Date',
  category:       'Category',
  images:         'Image',
  image:          'Image',
}
